import React, { useEffect, useState } from "react";
import { Table, Button, message, Select, Card, Pagination, Input } from "antd";
import ZipFilesService from "../../services/zipFilesService";

const { Option } = Select;

const ZipFiles = () => {
  const [zipFiles, setZipFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [typeFilter, setTypeFilter] = useState("");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchSlug, setSearchSlug] = useState("");


  const fetchZipFiles = async (page) => {
  
    
  setLoading(true);
  try {
    const { data, total } = await ZipFilesService.getZipFiles(
      typeFilter,
      searchSlug,
      page,
      pageSize
    );

    setZipFiles(data);
    setTotalCount(total);
    setPageIndex(page);
  } catch (err) {
    message.error("Failed to load zip files");
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  fetchZipFiles(0);
}, [typeFilter, searchSlug]);


  const handleRecreate = async (type, id) => {
    setLoading(true);
    try {
      await ZipFilesService.recreateZip(type, id);
      message.success("ZIP recreated successfully");
      fetchZipFiles(typeFilter, pageIndex); // refresh current page
    } catch (err) {
      console.error(err);
      message.error("Failed to recreate ZIP");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    fetchZipFiles(page - 1);
  };

  const columns = [
    { title: "Slug", dataIndex: "slug", key: "slug" },
    { title: "Type", dataIndex: "type", key: "type" },
    // { title: "S3 Key", dataIndex: "s3Key", key: "s3Key" },
    { title: "Created At", dataIndex: "createdAt", key: "createdAt" },
    { title: "Updated At", dataIndex: "updatedAt", key: "updatedAt" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() =>
            handleRecreate(
              record.type,
              record.type === "item" ? record.itemId : record.categoryId
            )
          }
        >
          Recreate
        </Button>
      ),
    },
  ];

  return (
    <Card title="ZIP Files">
      <div style={{ marginBottom: 16, display: "flex", gap: 12 }}>
        <Select
          placeholder="Filter by type"
          style={{ width: 200 }}
          onChange={(value) => setTypeFilter(value)}
          allowClear
        >
          <Option value="item">Item</Option>
          <Option value="category">Category</Option>
        </Select>

         <Input.Search
    placeholder="Search by slug"
    allowClear
    style={{ width: 260 }}
    onSearch={(value) => setSearchSlug(value)}
    onChange={(e) => {
      if (!e.target.value) setSearchSlug("");
    }}
  />
      </div>

      <Table
        columns={columns}
        dataSource={zipFiles}
        rowKey={(record) => record._id}
        loading={loading}
        pagination={false}
      />

      <div style={{ marginTop: 16, display: "flex", justifyContent: "end" }}>
        <Pagination
        simple
          current={pageIndex + 1}
          pageSize={pageSize}
          total={totalCount}
        defaultCurrent={1}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </Card>
  );
};

export default ZipFiles;
